/* unplugin-vue-components disabled */import { render } from "./MyLoading.vue?vue&type=template&id=20345879&scoped=true"
const script = {}

import "./MyLoading.vue?vue&type=style&index=0&id=20345879&lang=less&scoped=true"

import exportComponent from "/Users/xiaomingtongxue/Library/Mobile Documents/com~apple~CloudDocs/Documents/code/heart-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20345879"]])

export default __exports__